const initialState = {
  email: null,
  name: null,
  id: null,
  image: null,
  usertype: null,
  status: null,
  is_admin: null,
  logo: null,
  site_text: null
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_USER":
      return {
        ...state,
        email: action.payload.email,
        name: action.payload.name,
        id: action.payload.id,
        image: action.payload.image,
        usertype: action.payload.usertype,
        status: action.payload.status,
        is_admin: action.payload.is_admin,
        logo: action.payload.logo,
        site_text: action.payload.site_text,
      };

    case "LOGOUT_USER":
      return { ...initialState };

    default:
      return state;
  }
};

export default userReducer;


